var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 321.3 296",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "loading",
    points: "163,23.8 203.2,105.3 293.2,118.4 228.1,181.8 243.5,271.4 163,229.1 82.5,271.4 97.9,181.8  32.8,118.4 122.8,105.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "broken"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "62,158.7 31.9,109 67.6,113  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "91.1,221.6 97.9,181.8 74.4,158.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "135.3,253.9 62.5,274.2 81.3,227.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "276,151 231.2,184.5 234.8,275.4 160.5,223 146.2,228.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "198.1,75.5 212.2,104.1 302.2,117.1 277.1,141.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "142.9,57.9 167.2,23.5 184.8,79.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "broken",
    points: "97.2,96 118.2,87.9 129.5,40.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "broken",
    x1: 68.4,
    y1: 113.2,
    x2: 100.5,
    y2: 108.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLoading);
export default __webpack_public_path__ + "static/media/star-loading.4c137338951652df8121ad6f65e25351.svg";
export { ForwardRef as ReactComponent };